export {default as zoom} from "./src/zoom";
export {default as zoomTransform, identity as zoomIdentity} from "./src/transform";



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-zoom/index.js
// module id = ../../../../d3-zoom/index.js
// module chunks = 3